import React, { useState, useRef, useEffect } from 'react';
import '../styles/Accordion.css'

interface AccordionItem {
  title: string;
  content: React.ReactNode; // allows JSX or string
}

interface AccordionProps {
  items: AccordionItem[];
  allowMultipleOpen?: boolean;
}

const Accordion: React.FC<AccordionProps> = ({ items, allowMultipleOpen = false }) => {
  const [activeIndices, setActiveIndices] = useState<number[]>([]);
  const accordionRef = useRef<HTMLDivElement>(null);

  const toggleItem = (index: number) => {
    const wasActive = activeIndices.includes(index);
    
    if (allowMultipleOpen) {
      setActiveIndices((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    } else {
      setActiveIndices((prev) =>
        prev.includes(index) ? [] : [index]
      );
    }

    // Scroll to top of accordion when switching to a different item
    if (!allowMultipleOpen && !wasActive && accordionRef.current) {
      setTimeout(() => {
        accordionRef.current?.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }, 100); // Small delay to allow content to expand
    }
  };

  return (
    <div className="accordion" ref={accordionRef}>
      {items.map((item, index) => {
        const isActive = activeIndices.includes(index);
        return (
          <div className="accordion-item" key={index}>
            <button
              className={`accordion-header ${isActive ? 'active' : ''}`}
              onClick={() => toggleItem(index)}
            >
              {isActive ? '−' : '+'} {item.title}
            </button>
            <div className={`accordion-content ${isActive ? 'open' : ''}`}>
              {item.content}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
